// PerformerCard.js
import React from 'react';

const PerformerCard = ({ title, performers, id, unit }) => {
    const imageURL = process.env.REACT_APP_IMAGE_URL;
    const defaultPlayerImage = `${imageURL}player-thumb.jpg`;
    const defaultTeamImage = `${imageURL}default-team-logo.png`;
    const handleImageError = (e) => {
        e.target.src = defaultPlayerImage;
    };
    const handleTeamImageError = (e) => {
        e.target.src = defaultTeamImage;
    };

    return (
        <div className="col s12 m6 l3 ">
            <div id={`${id}`}>
                <h5 className="mcTitle">{title}</h5>
                <div className="mcPerformersList">
                    {performers.map((player, index) => (
                        index === 0 ? (
                            <a key={player.PlayerID} className="mcTopOne">
                                <span className="mcPlyImg">
                                    <img
                                        alt={player.PlayerName} onError={handleImageError}
                                        className=""
                                        src={player.profileimg || defaultPlayerImage}
                                    />
                                </span>
                                <span className="mcTopOneDetail">
                                    <span className="mcTopPlyName">{player.PlayerName}</span>
                                    <span className="mcTopScore">
                                        {player.KPIValues} <span className="topCategory">{unit}</span>
                                    </span>
                                    <span className="mcTopTeamName">{player.TeamName}</span>
                                </span>
                            </a>
                        ) : (
                            <div key={player.PlayerID} className="mcOtherTpp">
                                <p className="plyImg">
                                    <img
                                        alt={player.PlayerName} onError={handleImageError}
                                        className=""
                                        src={player.profileimg || defaultPlayerImage}
                                    />
                                </p>
                                <p className="plyName">
                                    {player.PlayerName}
                                    <span>{player.TeamName}</span>
                                </p>
                            </div>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
}

export default PerformerCard;